/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WMMaterialEntryDTO
 */
export interface WMMaterialEntryDTO {
    /**
     * 
     * @type {string}
     * @memberof WMMaterialEntryDTO
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof WMMaterialEntryDTO
     */
    containerCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WMMaterialEntryDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WMMaterialEntryDTO
     */
    locationCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WMMaterialEntryDTO
     */
    materialCode?: string;
    /**
     * 
     * @type {number}
     * @memberof WMMaterialEntryDTO
     */
    qty?: number;
    /**
     * 
     * @type {string}
     * @memberof WMMaterialEntryDTO
     */
    warehouseCode?: string;
}

/**
 * Check if a given object implements the WMMaterialEntryDTO interface.
 */
export function instanceOfWMMaterialEntryDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WMMaterialEntryDTOFromJSON(json: any): WMMaterialEntryDTO {
    return WMMaterialEntryDTOFromJSONTyped(json, false);
}

export function WMMaterialEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WMMaterialEntryDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'containerCode': !exists(json, 'containerCode') ? undefined : json['containerCode'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'locationCode': !exists(json, 'locationCode') ? undefined : json['locationCode'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'warehouseCode': !exists(json, 'warehouseCode') ? undefined : json['warehouseCode'],
    };
}

export function WMMaterialEntryDTOToJSON(value?: WMMaterialEntryDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
        'containerCode': value.containerCode,
        'id': value.id,
        'locationCode': value.locationCode,
        'materialCode': value.materialCode,
        'qty': value.qty,
        'warehouseCode': value.warehouseCode,
    };
}

